import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('loading-element')
export class LoadingElement extends LitElement {
    @property({ type: String })
    loadingString: String = 'Loading';

    @property({ type: Boolean })
    horizontal: Boolean = false;

    @property({ type: Boolean })
    small: Boolean = false;

    protected render() {
        return html`
            <div class="loading-element__wrapper ${this.horizontal === true ? 'horizontal' : ''}">
                <div class="spinner ${this.small === true ? 'small' : ''}"></div>
                <div class="loading-element__loading-string">
                    <span>${this.loadingString}</span>
                </div>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            :host {
                width: 100%;
            }

            .loading-element__wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
            }

            .spinner {
                margin: 10px;
                width: 20px;
                height: 20px;
                border: 5px solid #e0e0e0;
                border-top: 5px solid #4a90d9;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }

            .spinner.small {
                margin: 5px;
                width: 12px;
                height: 12px;
                border-width: 3px;
            }

            .horizontal {
                flex-direction: row;
            }

            @keyframes spin {
                to { transform: rotate(360deg); }
            }
        `;
    }
}
